import React, { useEffect, useRef, useState } from 'react';
import { AssetVariant } from '../mediaAssetCache';
import { useAssetUrl } from './VaultPrivateAsset';
export function VaultAsset({source, variant='thumbnail', video=false, eager=false, alt, onOpen}: {source:string;variant?:AssetVariant;video?:boolean;eager?:boolean;alt:string;onOpen?:()=>void}) {
  const root = useRef<HTMLDivElement>(null);
  const [visible,setVisible] = useState(eager);
  const [loaded,setLoaded] = useState('');
  const [failed,setFailed] = useState('');
  const {url,error,retry} = useAssetUrl(source, video ? 'original' : variant, visible);
  useEffect(()=>{
    if(eager || !window.IntersectionObserver){setVisible(true);return;}
    const observer = new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){setVisible(true);observer.disconnect();}}, {rootMargin:'200px'});
    if(root.current) observer.observe(root.current);
    return ()=>observer.disconnect();
  },[eager]);
  const unavailable = error || (!!url && failed===url);
  const loading = !unavailable && (!url || loaded!==url);
  return <div ref={root} className={`vault-asset ${variant==='preview'?'preview':''}`}>
    {loading && <div className="vault-status" role="status"><span className="vault-spinner"/>Loading {video?'video':'image'}…</div>}
    {unavailable && <div className="vault-status" role="alert">Couldn’t load this {video?'video':'image'}.<button onClick={()=>{setFailed('');setLoaded('');retry();}}>Retry</button></div>}
    {url && !unavailable && (video ? <video key={url} src={url} controls playsInline preload="metadata" onLoadedMetadata={()=>setLoaded(url)} onError={()=>setFailed(url)}/> :
      <img key={url} src={url} alt={alt} loading={eager?'eager':'lazy'} decoding="async" onLoad={()=>setLoaded(url)} onError={()=>setFailed(url)} style={{opacity:loaded===url?1:0}}/>)}
    {onOpen && !unavailable && <button className="vault-open" aria-label={`Open ${alt}`} onClick={onOpen}/>}
  </div>;
}
